export default import.meta.ROLLDOWN_FILE_URL_uwlzwyz9B1JDA1NXIl7hCw